import React from 'react';

import { Box, Typography } from '@mui/joy';
import { observer } from 'mobx-react-lite';

const RallyEditor: React.FC = () => (
  <Box sx={{ p: 1 }}>
    <Typography level='body-sm'>Rally Point Editor (coming soon)</Typography>
  </Box>
);

export default observer(RallyEditor);
